/** Product lockup: pink mark + PLAYER/DNA wordmark. Matches the app at app.playerdna.com. */
export function BrandLogo({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 leading-none ${className}`} role="img" aria-label="PlayerDNA">
      <svg viewBox="0 0 267.67 210.77" className="h-[26px] w-auto fill-brand" aria-hidden="true">
        <path d="M267.67 110.58 L229.08 149.17 L133.84 149.17 L133.84 105.38 L200.56 105.38 L177.50 82.33 L95.17 0.00 L157.09 0.00Z" />
        <path d="M172.50 210.77 L110.58 210.77 L0.00 100.19 L38.59 61.60 L133.84 61.60 L133.84 105.39 L67.11 105.39 L90.18 128.44Z" />
      </svg>
      <span className="text-[17px] font-extrabold tracking-[0.06em] text-ink" aria-hidden="true">
        PLAYER<span className="text-brand">DNA</span>
      </span>
    </span>
  );
}
